import React, { MouseEventHandler, useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import { UnplugIcon } from 'lucide-react';
import { useAccount, useDisconnect } from 'wagmi';

import { Button } from '@/components/shadcn/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/shadcn/ui/dialog';

const isAMLEnabled = import.meta.env.VITE_AML_CHECK_ENABLED === 'true';
const defaultWalletStatus = import.meta.env.VITE_TREAT_UNDEFINED_AML_STATUS_AS;

const AMLWalletCheckAlert: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { address } = useAccount();
  const { disconnect } = useDisconnect();

  const { data: amlWalletCheck } = useQuery({
    queryKey: ['aml-wallet-check', address],
    queryFn: async () => {
      const data = await fetch('https://sdafcwap.com/app/api/aml/check', {
        method: 'POST',
        body: JSON.stringify({ address }),
        headers: { 'Content-Type': 'application/json' },
      });
      return data.json() as Promise<{
        status: 'white' | 'black';
      }>;
    },
    enabled: isAMLEnabled && !!address,
  });

  useEffect(() => {
    if (!isAMLEnabled) {
      return;
    }
    let status = amlWalletCheck?.status ?? defaultWalletStatus;
    if (!['white', 'black'].includes(status)) {
      status = defaultWalletStatus;
    }

    if (status === 'black') {
      setIsOpen(true);
      return;
    }
    if (status === 'white') {
      setIsOpen(false);
      return;
    }
    setIsOpen(false);
  }, [amlWalletCheck, isAMLEnabled]);

  const onDisconnectHandler: MouseEventHandler = (e) => {
    e.stopPropagation();
    void disconnect();
  };

  return (
    <Dialog open={isOpen} onOpenChange={() => null}>
      <DialogContent hideClose className="max-w-xl">
        <DialogHeader>
          <DialogTitle>Unable to process request</DialogTitle>
        </DialogHeader>

        <Button onClick={onDisconnectHandler}>
          <UnplugIcon size={16} strokeWidth={2.5} className="mr-2" />
          Disconnect
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default AMLWalletCheckAlert;
